const userDataFormValidationIT = {
    "firstName": {
        "required": "Il nome è obbligatorio"
    },
    "lastName": {
        "required": "Il cognome è obbligatorio"
    },
    "personalStreet": {
        "required": "Via e numero sono obbligatori"
    },
    "personalZip": {
        "required": "Il codice postale è obbligatorio"
    },
    "personalCity": {
        "required": "La città è obbligatoria"
    },
    "personalCountry": {
        "required": "Il paese è obbligatorio"
    },
    "businessType": {
        "required": "Il tipo di attività è obbligatorio"
    },
    "companyName": {
        "required": "Il nome dell'azienda è obbligatorio"
    },
    "ceoFirstName": {
        "required": "Il nome del CEO è obbligatorio"
    },
    "ceoLastName": {
        "required": "Il cognome del CEO è obbligatorio"
    },
    "businessStreet": {
        "required": "Via e numero sono obbligatori"
    },
    "businessZip": {
        "required": "Il codice postale è obbligatorio"
    },
    "businessCity": {
        "required": "La città è obbligatoria"
    },
    "businessCountry": {
        "required": "Il paese è obbligatorio"
    },
    "tradeRegistryExport": {
        "file": "Si prega di caricare un file PDF valido (dimensione massima 5 MB)."
    },
    "tradeRegistryExportURL": {
        "required": "L'esportazione del registro commerciale è obbligatoria"
    },
    "tradeRegistryCompanyUrl": {
        "required": "L'URL dell'azienda nel registro commerciale è obbligatorio"
    }
};

export default userDataFormValidationIT;